module.exports = __webpack_public_path__ + "static/media/Order-Create.4d9157dc.png";